// src/utils/relatedWorks.js

export const overlapCount = (a = [], b = []) => {
  const setB = new Set(b);
  return (a ?? []).reduce((acc, x) => acc + (setB.has(x) ? 1 : 0), 0);
};

export const relatedScore = (w, current) => {
  const service = overlapCount(w?.serviceTags ?? [], current?.serviceTags ?? []) * 3;
  const purpose = overlapCount(w?.purposeTags ?? [], current?.purposeTags ?? []) * 2;
  return service + purpose;
};
